import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, grey } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const defaultColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--status-default-color-main'],
          highContrast: unityLightTokens['--status-default-color-high-contrast'],
          lowContrast: unityLightTokens['--status-default-color-low-contrast'],
        }
      : {
          main: unityDarkTokens['--status-default-color-main'],
          highContrast: unityDarkTokens['--status-default-color-high-contrast'],
          lowContrast: unityDarkTokens['--status-default-color-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: grey[400],
        highContrast: grey[700],
        lowContrast: grey[150],
      }
    : {
        main: grey[400],
        highContrast: grey[150],
        lowContrast: grey[800],
      };
};
